/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/DoneAll';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const DoneAllIcon = withMuiAdapter(Base, 'DoneAll');
